module.exports = __webpack_public_path__ + "img/2x.2e577a8.jpg";